import React from 'react';

function Error(props) {


    return (<div>

        <h1 style={{'textAlign':'center'} }>Sorry,Page not found</h1>


    </div>);
}

export default Error;